
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="班级:">
        <el-select v-model="classId" @change="changeClass" placeholder="请选择">
          <el-option
            v-for="item in classData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="mide" type="primary" @click="handleEdit()"
          >添加学生账号</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button size="mide" @click="enterDataVis = true">
          导入账号
        </el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="导入账号" :visible.sync="enterDataVis" width="40%">
      <el-upload
        accept=".txt"
        class="upload-demo"
        action="https://jsonplaceholder.typicode.com/posts/"
        :on-change="handlePreview"
        :on-remove="handleRemove"
        multiple
        :limit="1"
        :file-list="fileList"
      >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">请上传.txt文件</div>
      </el-upload>
      <!-- <div class="fsc nopBox">
        <div class="nopassword">默认密码：</div>
        <el-input
          class="nopinputBox"
          v-model="morenpassword"
          placeholder="请输入内容"
        ></el-input>
      </div> -->
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="enterDataVis = false">取消</el-button>
        <el-button
          size="small"
          type="primary"
          class="title"
          @click="enterUserList"
          >确认上传</el-button
        >
      </div>
    </el-dialog>
    <!--列表-->

    <el-table
      size="small"
      :data="listData.students"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="account" label="账号名称"> </el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <!-- <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="账号" prop="account">
          <el-input
            size="small"
            v-model="editForm.account"
            auto-complete="off"
            placeholder="请输入账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            size="small"
            v-model="editForm.password"
            auto-complete="off"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="学校" v-if="userdata.role == 128" prop="schoolId">
          <el-select v-model="editForm.schoolId" placeholder="请选择">
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号类型" v-if="userdata.role == 64" prop="role">
          <el-select v-model="editForm.role" placeholder="请选择">
            <el-option
              v-for="item in rowList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            size="small"
            v-model="editForm.name"
            auto-complete="off"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="班级"
          v-if="userdata.role == 8 || editForm.role == 1"
        >
          <el-select v-model="editForm.classId" placeholder="请选择">
            <el-option
              v-for="item in classData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="编辑账号" :visible.sync="edVisible" width="30%">
      <el-form
        label-width="120px"
        :model="edfromData"
        :rules="edrules"
        ref="edForm"
      >
        <el-form-item label="新账号" prop="new_account">
          <el-input
            size="small"
            v-model="edfromData.new_account"
            auto-complete="off"
            placeholder="请输入新账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input
            size="small"
            v-model="edfromData.new_password"
            auto-complete="off"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>

        <el-form-item label="新姓名" prop="new_name">
          <el-input
            size="small"
            v-model="edfromData.new_name"
            auto-complete="off"
            placeholder="请输入新姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="新班级" v-if="userdata.role == 64">
          <el-select v-model="edfromData.new_classId" placeholder="请选择">
            <el-option
              v-for="item in classData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="edVisible = false">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitFormed('edForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  accountlist,
  accountcreate,
  accountdelete,
  accountedit,
  schoollist,
  classlist,
  accountinfo,
  importuser,
} from "@/api/userMG";
import Pagination from "@/components/Pagination";
export default {
  data() {
    return {
      morenpassword: "",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        account: "",
        password: "",
        schoolId: "",
        role: "",
        name: "",
        classId: "",
      },
      edfromData: {
        id: "",
        new_account: "",
        new_password: "",
        new_name: "",
        new_classId: "",
      },
      edVisible: false,
      // rules表单验证
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: this.$pswcheck, trigger: "blur" },
        ],
        schoolId: [
          { required: true, message: "请选择学校", trigger: "change" },
        ],
        role: [
          { required: true, message: "请选择账号类型", trigger: "change" },
        ],
        classId: [{ required: true, message: "请选择班级", trigger: "change" }],
      },
      edrules: {
        new_account: [
          { required: true, message: "请输入新账号", trigger: "blur" },
        ],
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: this.$pswcheck, trigger: "blur" },
        ],
        new_name: [
          { required: true, message: "请输入新姓名", trigger: "blur" },
        ],
      },

      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      userdata: {},
      schoolList: [],
      rowList: [
        { id: "1", name: "学生" },
        { id: "8", name: "教师" },
      ],
      classData: [],
      classId: "",
      enterDataVis: false,
      fileList: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.userdata = this.$store.state.usuerdata;
    this.schoollistfn();
    this.getclasslist();
  },

  methods: {
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePreview(file, fileList) {
      this.fileList = fileList;
    },
    enterUserList() {
      let vm = this;
      // if (!vm.morenpassword) {
      //   return vm.$message({
      //     type: "warning",
      //     message: "请输入默认密码",
      //   });
      // }
      // if (!this.$pswtest(vm.morenpassword)) {
      //   this.$message.warning(
      //     "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！"
      //   );
      //   return;
      // }
      if (this.fileList.length <= 0) {
        return vm.$message({
          type: "warning",
          message: "请选择文件",
        });
      }
      let file = this.fileList[0].raw;
      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = function (resdata) {
        let list = resdata.target.result.split("\r\n");
        let params = {
          role: 1,
          ids: list,
          classId: vm.classId,
          // password: vm.morenpassword,
          password: 'SXwl123#'
        };
        importuser(params).then((res) => {
          vm.enterDataVis = false;
          vm.$message({
            type: "success",
            message: "添加成功！",
          });
          vm.getdata(vm.classId);
        });
      };
    },
    changeClass() {
      this.getdata(this.classId);
    },
    getclasslist() {
      classlist().then((res) => {
        console.log(res, "class");
        this.classData = [];
        this.classData = res;
        if (res.length > 0) {
          this.classId = this.classData[0].id;
          this.getdata(this.classId);
        }
      });
    },
    schoollistfn() {
      schoollist().then((res) => {
        this.schoolList = res;
      });
    },

    getdata(params) {
      accountlist(params).then((res) => {
        this.listData = [];
        this.listData = res;
        console.log(res, "resss");
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit(row) {
      this.editForm.account = "";
      this.editForm.password = "";
      this.editForm.schoolId = "";
      this.editForm.id = "";
      this.editForm.role = "";
      this.editForm.name = "";
      this.editForm.classId = "";

      this.edfromData.id = "";
      this.edfromData.new_account = "";
      this.edfromData.new_password = "";
      this.edfromData.new_name = "";
      this.edfromData.new_classId = "";

      if (row != undefined && row != "undefined") {
        this.edVisible = true;

        accountinfo(row.id).then((res) => {
          this.edfromData.id = res.id;
          this.edfromData.new_account = res.account;
          this.edfromData.new_password = "";
          this.edfromData.new_name = res.name;
          this.edfromData.new_classId = res.classId;
        });
      } else {
        this.editFormVisible = true;
        this.title = "添加";
      }
    },
    // 编辑、增加页面保存方法
    submitFormed(edForm) {
      this.$refs[edForm].validate((valid) => {
        if (valid) {
          if (this.userdata.role == 8) {
            Reflect.deleteProperty(this.edfromData, "new_classId");
          }
          if (!this.$pswtest(this.edfromData.new_password)) {
            this.$message.warning(
              "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！"
            );
            return;
          }
          accountedit(this.edfromData.id, this.edfromData)
            .then((res) => {
              console.log(res);
              this.edVisible = false;
              this.loading = false;
              this.$message({
                type: "success",
                message: "添加成功！",
              });
              this.getdata(this.classId);
            })
            .catch((err) => {
              this.edVisible = false;
              this.loading = false;
              this.$message.error(err.response.data.msg);
            });
        }
      });
    },
    submitForm(editData) {
      if (this.userdata.role == 128) {
        Reflect.deleteProperty(this.editForm, "role");
        Reflect.deleteProperty(this.editForm, "classId");
      }
      if (this.userdata.role == 64) {
        Reflect.deleteProperty(this.editForm, "schoolId");
        if (this.editForm.role == 8) {
          Reflect.deleteProperty(this.editForm, "classId");
        }
        this.editForm.role = Number(this.editForm.role);
      }

      if (!this.$pswtest(this.editForm.password)) {
        this.$message.warning(
          "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！"
        );
        return;
      }

      this.$refs[editData].validate((valid) => {
        if (valid) {
          if (!this.editForm.id) {
            Reflect.deleteProperty(this.editForm, "id");
            accountcreate(this.editForm)
              .then((res) => {
                console.log(res);
                this.editFormVisible = false;
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "添加成功！",
                });
                this.getdata(this.classId);
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error(err.response.data.msg);
              });
          } else {
            accountedit(this.editForm.id, this.editForm)
              .then((res) => {
                console.log(res);
                this.editFormVisible = false;
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "修改成功！",
                });
                this.getdata(this.classId);
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error(err.response.data.msg);
              });
          }
        } else {
          return false;
        }
      });
    },

    deleteUser(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          accountdelete(row.id)
            .then((res) => {
              this.$message({
                type: "success",
                message: "已删除!",
              });
              this.getdata(this.classId);
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.el-alert {
  margin-bottom: 20px;
}

.fsc {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.nopBox {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.nopassword {
  width: 100px;
}
.nopinputBox {
  width: 200px;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/useradmin/user.vue